import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {AuthServiceService} from '../../auth-pages/services/auth-service.service';

declare const $: any;

declare interface RouteInfo {
    path: string;
    title: string;
    icon: string;
    class: string;
}

export const ROUTES: RouteInfo[] = [
    {path: '/admin/dashboards', title: 'Dashboard', icon: 'dashboard', class: ''},
    {path: '/admin/sent-messages', title: 'Sent Messages', icon: 'forward_to_inbox', class: ''},
    {path: '/admin/group-messages', title: 'Group Messages', icon: 'mail_outline', class: ''},
    {path: '/admin/scheduled-messages', title: 'Scheduled Messages', icon: 'schedule_send', class: ''},
    {path: '/admin/received-messages', title: 'Received Messages', icon: 'textsms', class: ''},
    {path: '/admin/chats', title: 'Conversations', icon: 'chat', class: ''},
    {path: '/admin/contacts', title: 'Contacts', icon: 'contacts', class: ''},
    {path: '/admin/menu-builder', title: 'Menu Builder', icon: 'store', class: ''},
    {path: '/admin/subscriptions', title: 'Subscriptions', icon: 'subscriptions', class: ''},
    {path: '/admin/drip-feeds', title: 'Drip Feeds', icon: 'water_drop', class: ''},
    {path: '/admin/message-ports', title: 'Message Ports', icon: 'import_export', class: ''},
    {path: '/admin/users', title: 'Users', icon: 'person', class: ''},
    {path: '/admin/settings', title: 'Settings', icon: 'settings', class: ''},
];

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {
    menuItems: any[];

    constructor(private router: Router, private authService: AuthServiceService) {
    }

    ngOnInit() {
        this.menuItems = ROUTES.filter(menuItem => menuItem);
    }

    isMobileMenu() {
        if ($(window).width() > 991) {
            return false;
        }
        return true;
    };
    public logout() {
        this.authService.logOut();
    }
}
